import { reactive } from 'vue'

export function createStore(gommistaId) {
  return reactive({
    gommistaId: gommistaId || '',
    gommista: null,
    slots: [],
    dateStart: null,
    dateStop: null,
    loading: false,
    error: null,
    step: 'slot',
    selectedSlot: null,
    datiPrenotazione: {},
  })
}
